<template>
  <OurConfirmModal
    v-model="isShownModal"
    :title="$t('title.promotions.delete')"
    :action-button-text="$t('button.remove')"
    color="gray"
    @actionConfirmed="onConfirm"
  >
    <OurTextBlock>
      <span v-html="$t('promotions.deleteConfirm', { name })" />
    </OurTextBlock>
  </OurConfirmModal>
</template>

<script>
export default {
  name: "DeletePromotionModal",

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    promotionId: {
      type: String,
      default: "",
    },

    name: {
      type: String,
      default: "",
    },
  },

  computed: {
    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
  },
};
</script>
